module.exports = __webpack_public_path__ + "static/media/Clauncher_gaussian2.51b2b8ed.png";